import styles from './WikiLoveMonuments.module.css'
import WikiLogo from '../../../assets/wiki-primary.svg?react'
import Close from '../../../assets/close.svg?react'
import { useTranslation } from 'react-i18next'
import { Geocontext } from '../../../types'
import { useMemo } from 'react'

interface Props {
  infoWiki: boolean
  setInfoWiki: (infoWiki: boolean) => void
  setPresentazione: (presentazione: boolean) => void
  activeGeocontext?: Geocontext
}

export default function WikiLoveMonuments({
  infoWiki,
  setInfoWiki,
  setPresentazione,
  activeGeocontext,
}: Props) {
  const { i18n, t } = useTranslation()

  const textIntro = useMemo(() => {
    if (!activeGeocontext) return ''
    if (
      activeGeocontext.intro_texts[i18n.language] &&
      activeGeocontext.intro_texts[i18n.language] !== ''
    ) {
      return activeGeocontext.intro_texts[i18n.language]
    }
    if (activeGeocontext.fallback_language_donation_intro) {
      const fallbackCode =
        activeGeocontext.fallback_language_donation_intro.code
      if (
        activeGeocontext.intro_texts[fallbackCode] &&
        activeGeocontext.intro_texts[fallbackCode] !== ''
      ) {
        return activeGeocontext.intro_texts[fallbackCode]
      }
    }
  }, [activeGeocontext, i18n.language])

  return (
    <div
      className={styles.WikiLoveMonuments}
      style={{
        opacity: infoWiki ? '1' : '0',
        pointerEvents: infoWiki ? 'all' : 'none',
        transition: 'all 0.5s ease-in-out',
      }}
    >
      <div className={styles.TopWikiLove}>
        <div className={styles.WikiLoveLabel}>
          <WikiLogo />
          <span className="ms-2">{t('GENERIC_WLM')}</span>
        </div>
        <div className="pointer">
          <Close onClick={() => setInfoWiki(false)} />
        </div>
      </div>
      <div className="mt-4">
        {!!activeGeocontext && (
          <div
            className={styles.TextWikiLove}
            dangerouslySetInnerHTML={{
              __html: textIntro ?? '',
            }}
          ></div>
        )}
        <div
          className={styles.ButtonRivediTutorial}
          onClick={() => {
            setInfoWiki(false)
            setPresentazione(true)
          }}
        >
          <strong>{t('WHT_WLM_WATCH_AGAIN')}</strong>
        </div>
      </div>
    </div>
  )
}
